module.exports = __webpack_public_path__ + "img/main_Rentrit.c1fa942b.jpg";